
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.145 9.453a.86.86 0 00-.86-.86H4.434a.86.86 0 100 1.72h8.851a.86.86 0 00.86-.86zM4.434 12.031a.86.86 0 000 1.719h5.375a.86.86 0 100-1.719H4.434z","fill":"var(--theme-color-white-text)"}}),_c('path',{attrs:{"d":"M6.452 20.281H3.578a1.72 1.72 0 01-1.719-1.718V3.438a1.72 1.72 0 011.72-1.72h10.565a1.72 1.72 0 011.718 1.72v5.285a.86.86 0 001.72 0V3.437A3.441 3.441 0 0014.143 0H3.578A3.441 3.441 0 00.141 3.438v15.124A3.441 3.441 0 003.578 22h2.874a.86.86 0 100-1.719z","fill":"var(--theme-color-white-text)"}}),_c('path',{attrs:{"d":"M19.104 12.441a2.581 2.581 0 00-3.645 0l-4.718 4.707c-.1.1-.174.224-.215.36L9.498 20.89a.86.86 0 001.052 1.078l3.468-.961a.858.858 0 00.378-.22l4.708-4.7a2.581 2.581 0 000-3.646zm-5.762 6.97l-1.745.483.51-1.681 3.184-3.177 1.216 1.216-3.165 3.159zm4.548-4.54l-.167.167-1.215-1.216.166-.165a.86.86 0 011.216 1.215zM13.285 5.156H4.434a.86.86 0 100 1.719h8.851a.86.86 0 000-1.719z","fill":"var(--theme-color-white-text)"}})])
          )
        }
      }
    